<div class="widget canvas-dropzone whiteboardwidget" oncontextmenu="return false;">

  <div clasS="button-wrapper" *ngIf="isUndocked">
    <div class="custom-tool-bar">

      <div class="label-button">
        <div class="label" [translate]="'widgets.whiteboard.fullscreen'">Fullscreen</div>
        <button mat-raised-button class="fullscreenButton" (click)="onClickFullscreen($event)">
          <mat-icon class="fs-inner">fullscreen</mat-icon>
        </button>
      </div>

      <div class="btn-divider"></div>

      <div class="label-button" id="btn-select">
        <div class="label" [translate]="'widgets.whiteboard.select'">Select</div>
        <button mat-raised-button class="selectButton" (click)="onClickSetDrawingMode(this.DM.SELECTION)">
          <mat-icon class="fs-inner">tab_unselected</mat-icon>
        </button>
      </div>

      <div class="label-button label-button-selected" id="btn-free">
        <div class="label" [translate]="'widgets.whiteboard.free'">Free</div>
        <button mat-raised-button class="selectButton" (click)="onClickSetDrawingMode(this.DM.PENCIL)">
          <mat-icon class="fs-inner">edit</mat-icon>
        </button>
      </div>

      <!-- Draw Mode Selection -->
      <div class="label-button" id="btn-basic">
        <div class="label" [translate]="'widgets.whiteboard.mode'">Mode</div>
        <button mat-raised-button class="toolButton paintModeSelect">
          <mat-icon class="pms-inner">show_chart</mat-icon>
          <mat-select>
            <mat-option (click)="onClickSetDrawingMode(this.DM.LINE)">
              <mat-icon class="fs-inner-pencil">show_chart</mat-icon>
            </mat-option>
            <mat-option (click)="onClickSetDrawingMode(this.DM.RECTANGLE)">
              <mat-icon class="fs-inner-shape">crop_din</mat-icon>
            </mat-option>
            <mat-option (click)="onClickSetDrawingMode(this.DM.ELLIPSE)">
              <mat-icon class="fs-inner-circle">panorama_fish_eye</mat-icon>
            </mat-option>
            <mat-option (click)="onClickSetDrawingMode(this.DM.TEXT)">
              <mat-icon class="fs-inner-text">format_color_text</mat-icon>
            </mat-option>
          </mat-select>
        </button>
      </div>

      <!-- advanced shape selection -->
      <div class="label-button" id="btn-advanced">
        <div class="label" [translate]="'widgets.whiteboard.mode_shapes'">Mode Shapes</div>
        <button mat-raised-button class="toolButton paintModeSelect">
          <mat-icon class="pms-inner-ms">credit_card</mat-icon>
          <mat-select>
            <mat-option (click)="onClickSetDrawingMode(this.DM.UML)">
              <mat-icon class="fs-inner-uml">credit_card</mat-icon>
            </mat-option>
            <mat-option (click)="onClickSetDrawingMode(this.DM.UML_DIAMOND)">
              <mat-icon class="fs-inner-uml fs-inner-angled">crop_square</mat-icon>
            </mat-option>
            <mat-option (click)="onClickSetDrawingMode(this.DM.SHAPE_PHONE)">
              <mat-icon class="fs-inner-uml">phone_iphone</mat-icon>
            </mat-option>
            <mat-option (click)="onClickSetDrawingMode(this.DM.SHAPE_TABLET)">
              <mat-icon class="fs-inner-uml">tablet</mat-icon>
            </mat-option>
            <mat-option (click)="onClickSetDrawingMode(this.DM.SHAPE_DESKTOP)">
              <mat-icon class="fs-inner-uml">desktop_windows</mat-icon>
            </mat-option>
          </mat-select>
        </button>
      </div>

      <!-- delete -->
      <div class="label-button">
        <div class="label" [translate]="'widgets.whiteboard.delete'">Delete</div>
        <button mat-raised-button class="toolButton deleteButton" (click)="onClickClearCanvas()">
          <mat-icon class="fs-inner-save">not_interested</mat-icon>
        </button>
      </div>

      <div class="btn-divider"></div>

      <!-- Stroke Width Selection -->
      <div class="label-button">
        <div class="label" [translate]="'widgets.whiteboard.stroke'">Stroke</div>
        <button mat-raised-button class="toolButton strokeButton" (click)="onClickStroke()">
          <mat-icon>fiber_manual_record</mat-icon>
        </button>
        <div class="stroke-wrapper s-wrapper">
          <input type="range" min="1" max="50" value="5" id="strokeRange" (input)="onStrokeChange()">
          <div class="stroke-preview">
            <div class="stroke-circle"></div>
          </div>
        </div>
      </div>


      <!-- stroke color Selection -->
      <div class="label-button">
        <div class="label" [translate]="'widgets.whiteboard.color'">Color</div>
        <button mat-raised-button class="toolButton colorButton" (click)="onClickColor()">
          <mat-icon class="colorIcon">color_lens</mat-icon>
        </button>
        <div class="color-wrapper c-wrapper">
          <div class="color-elements">
            <div class="color-panel">
              <div class="color-element blkL color-highlighted" (click)="onClickSetColor('#7f7f7f')"></div>
              <div class="color-element blkML" (click)="onClickSetColor('#595959')"></div>
              <div class="color-element blkM" (click)="onClickSetColor('#3f3f3f')"></div>
              <div class="color-element blkMD" (click)="onClickSetColor('#262626')"></div>
              <div class="color-element blkD" (click)="onClickSetColor('#0c0c0c')"></div>
            </div>
            <div class="color-panel">
              <div class="color-element bluL" (click)="onClickSetColor('#D9E2F3')"></div>
              <div class="color-element bluML" (click)="onClickSetColor('#B4C6E7')"></div>
              <div class="color-element bluM" (click)="onClickSetColor('#8EAADB')"></div>
              <div class="color-element bluMD" (click)="onClickSetColor('#2F5496')"></div>
              <div class="color-element bluD" (click)="onClickSetColor('#1F3864')"></div>
            </div>
            <div class="color-panel">
              <div class="color-element redL" (click)="onClickSetColor('#FBE5D5')"></div>
              <div class="color-element redML" (click)="onClickSetColor('#F7CBAC')"></div>
              <div class="color-element redM" (click)="onClickSetColor('#F4B183')"></div>
              <div class="color-element redMD" (click)="onClickSetColor('#C55A11')"></div>
              <div class="color-element redD" (click)="onClickSetColor('#833C0B')"></div>
            </div>
            <div class="color-panel">
              <div class="color-element ylwL" (click)="onClickSetColor('#FFF2CC')"></div>
              <div class="color-element ylwML" (click)="onClickSetColor('#FEE599')"></div>
              <div class="color-element ylwM" (click)="onClickSetColor('#FFD965')"></div>
              <div class="color-element ylwMD" (click)="onClickSetColor('#BF9000')"></div>
              <div class="color-element ylwD" (click)="onClickSetColor('#7F6000')"></div>
            </div>
            <div class="color-panel">
              <div class="color-element greL" (click)="onClickSetColor('#E2EFD9')"></div>
              <div class="color-element greML" (click)="onClickSetColor('#C5E0B3')"></div>
              <div class="color-element greM" (click)="onClickSetColor('#A8D08D')"></div>
              <div class="color-element greMD" (click)="onClickSetColor('#538135')"></div>
              <div class="color-element greD" (click)="onClickSetColor('#375623')"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- fill color Selection -->
      <div class="label-button">
        <div class="label" [translate]="'widgets.whiteboard.fill'">Fill</div>
        <button mat-raised-button class="toolButton fillButton" (click)="onClickFill($event)">
          <mat-icon class="fillIcon">format_color_fill</mat-icon>
        </button>
        <div class="color-wrapper f-wrapper">
          <div class="color-elements">
            <div class="color-panel">
              <div class="color-element trans color-highlighted" (click)="onClickSetFill('rgba(0,0,0,0)')"></div>
              <div class="color-element blkML" (click)="onClickSetFill('#595959')"></div>
              <div class="color-element blkM" (click)="onClickSetFill('#3f3f3f')"></div>
              <div class="color-element blkMD" (click)="onClickSetFill('#262626')"></div>
              <div class="color-element blkD" (click)="onClickSetFill('#0c0c0c')"></div>
            </div>
            <div class="color-panel">
              <div class="color-element bluL" (click)="onClickSetFill('#D9E2F3')"></div>
              <div class="color-element bluML" (click)="onClickSetFill('#B4C6E7')"></div>
              <div class="color-element bluM" (click)="onClickSetFill('#8EAADB')"></div>
              <div class="color-element bluMD" (click)="onClickSetFill('#2F5496')"></div>
              <div class="color-element bluD" (click)="onClickSetFill('#1F3864')"></div>
            </div>
            <div class="color-panel">
              <div class="color-element redL" (click)="onClickSetFill('#FBE5D5')"></div>
              <div class="color-element redML" (click)="onClickSetFill('#F7CBAC')"></div>
              <div class="color-element redM" (click)="onClickSetFill('#F4B183')"></div>
              <div class="color-element redMD" (click)="onClickSetFill('#C55A11')"></div>
              <div class="color-element redD" (click)="onClickSetFill('#833C0B')"></div>
            </div>
            <div class="color-panel">
              <div class="color-element ylwL" (click)="onClickSetFill('#FFF2CC')"></div>
              <div class="color-element ylwML" (click)="onClickSetFill('#FEE599')"></div>
              <div class="color-element ylwM" (click)="onClickSetFill('#FFD965')"></div>
              <div class="color-element ylwMD" (click)="onClickSetFill('#BF9000')"></div>
              <div class="color-element ylwD" (click)="onClickSetFill('#7F6000')"></div>
            </div>
            <div class="color-panel">
              <div class="color-element greL" (click)="onClickSetFill('#E2EFD9')"></div>
              <div class="color-element greML" (click)="onClickSetFill('#C5E0B3')"></div>
              <div class="color-element greM" (click)="onClickSetFill('#A8D08D')"></div>
              <div class="color-element greMD" (click)="onClickSetFill('#538135')"></div>
              <div class="color-element greD" (click)="onClickSetFill('#375623')"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-divider"></div>

      <!-- auto save DISABLED until fixed -->
      <!--
      <div class="label-button mat-raised-button toggle-button">
        <div class="label" [translate]="'widgets.whiteboard.auto'">Auto-Save</div>
        <label class="switch autosaveButotn">
          <input type="checkbox">
          <span class="slider round" (click)="onToggleAutosave()"></span>
        </label>
      </div>
      -->

      <!-- opacity -->
      <div class="label-button mat-raised-button toggle-button">
        <div class="label" [translate]="'widgets.whiteboard.opacity'">opacity</div>
        <label class="switch opacityButton">
          <input type="checkbox">
          <span class="slider round" (click)="onToggleOpacity()"></span>
        </label>
      </div>

      <!-- Snap DISABLED until fixed 
      <!-- 
      <div class="label-button mat-raised-button toggle-button">
        <div class="label">SNAP</div>
        <label class="switch opacityButton">
          <input type="checkbox">
          <span class="slider round" (click)="onToggleSnap()"></span>
        </label>
      </div>
      -->

      <div class="btn-divider"></div>

      <!-- History -->
      <div class="label-button">
        <div class="label" [translate]="'widgets.whiteboard.recent'">Recent</div>
        <button mat-raised-button class="historyButton" (click)="onClickRecent()">
          <i class="fa fa-history"></i>
        </button>
        <div class="history-wrapper">
          <div class="history-elements">
          </div>
        </div>
      </div>

      <div class="label-button">
        <div class="label" [translate]="'widgets.whiteboard.save'">Save</div>
        <button mat-raised-button (click)="onClickSaveBoard()">
          <mat-icon class="fs-inner">save</mat-icon>
        </button>
      </div>

      <div class="label-button">
        <div class="label" [translate]="'widgets.whiteboard.newboard'">New</div>
        <button mat-raised-button (click)="onClickNewBoard()">
          <mat-icon class="fs-inner">create_new_folder</mat-icon>
        </button>
      </div>

      <!-- DEV -->
      <div class="label-button" style="display: none;">
        <div class="label">CLEAR ALL</div>
        <button class="" (click)="onClickDeleteAll()">
          <i class="fa fa-bug"></i>
        </button>
      </div>

    </div>

  </div>

  <div class="canvas-wrapper" oncontextmenu="return false;">
    <div class="canvas-preview" *ngIf="!isUndocked"></div>
    <div class="canvas-hover"></div>
    <div class="save-hint">
      <mat-icon>save</mat-icon>
    </div>
    <div class="sel-context">
      <button class="deleteButton" (click)="onClickDeleteElement()">
        <mat-icon>delete</mat-icon>
      </button>
      <button class="newStoryButotn" (click)="onClickNewStory()">
        <mat-icon>create_new_folder</mat-icon>
      </button>
    </div>
    <canvas class=".main-container" id="myCanvas" oncontextmenu="return false;">
      Sorry, your browser does not support HTML5 canvas technology.
    </canvas>
    <canvas id="renderCanvas"></canvas>
    <canvas id="dynamicCanvas"></canvas>
  </div>
  <div class="downloadLinkHolder"></div>
</div>


<div class="widget-resizer">
  <mat-icon>code</mat-icon>
</div>


<div class="spinner-wrapper">
  <div class="left"><span></span></div>
  <div class="right"><span></span></div>
</div>

<div class="canvas-draggable"></div>
